import React from "react";
import { useNavigate } from "react-router-dom";
import "./Home.css";

import {
  FaInfoCircle,
  FaUser,
  FaGift,
  FaWallet,
  FaExchangeAlt,
  FaUsers,
} from "react-icons/fa";

function Home() {
  const navigate = useNavigate();

  const menuItems = [
    { title: "About Us", icon: <FaInfoCircle />, path: "/about" },
    { title: "BonusRecord", icon: <FaWallet />, path: "/record" },
    { title: "Iformation", icon: <FaWallet />, path: "/info" },
    { title: "Profile", icon: <FaUser />, path: "/profile" },
    { title: "Rules", icon: <FaWallet />, path: "/rules" },
    { title: "Settings", icon: <FaGift />, path: "/settings" },

  ];

  return (
    <div className="home-page">
      <div className="home-fixed-top">
        <h1>Home</h1>
      </div>

      <div className="home-scroll">
        <div className="menu-grid">
          {menuItems.map((item, index) => (
            <div
              key={index}
              className="menu-card"
              onClick={() => navigate(item.path)}
            >
              <div className="icon-box">{item.icon}</div>
              <p className="menu-title">{item.title}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default Home;